import React from 'react'
import GeneralInformation from './GeneralInformation'
import VendorInformationForm from './VendorInformation'
import AttachmentInformation from './AttachmentInformation'

const ShortListPart = (props) => {
  const { valueForm, change, isDisplay=false, generalDisplay = false , isDetail} = props
  return (
    // isDisplay ? 
    <React.Fragment>
      <GeneralInformation valueForm={valueForm} change={change} isDisplay={isDisplay || generalDisplay} isDetail={isDetail} />
      <VendorInformationForm valueForm={valueForm} change={change} isDisplay={isDisplay} />
      <AttachmentInformation valueForm={valueForm} change={change} isDisplay={isDisplay} />
    </React.Fragment> //:
    // <React.Fragment>
    //   <GeneralInformation valueForm={valueForm} change={change} isDisplay={isDisplay} />
    //   <VendorInformationForm valueForm={valueForm} change={change} isDisplay={isDisplay} />
    //   <AttachmentInformation valueForm={valueForm} change={change} isDisplay={isDisplay} />
    // </React.Fragment>
  )
}

export default ShortListPart